// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1cUNr","header":"ClearentDisclaimer_header__eBvJO","inner":"ClearentDisclaimer_inner__1LoFy"};